<script>
import {onMounted, onUnmounted, ref, watch} from "vue";
import {useRoute} from "vue-router";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import {useStore} from "vuex";

export default {
  name: "ChatsPage",
  components: {LoadingPage},
  setup() {
    let store = useStore()

    let info_chat = ref(FreeWorld.PinkMan(store.state.chat, 'de'))

    let loading = ref(false)

    let type = ref(useRoute().params.type)
    let user_id = ref(FreeWorld.PinkMan(localStorage.getItem('uid'), 'de'))

    let list_chats = ref([])
    let chats_length = ref(0)

    let text = ref('')

    let update_chat = null

    onMounted(() => {
        update_chat = setInterval(() => {show_history_text()}, 3000)
    })

    onUnmounted(() => {
      clearInterval(update_chat)
    })

    watch(() => chats_length.value, () => {
      setTimeout(() => {
        const chatList = document.getElementById('chat-list');
        chatList.scrollTop = chatList.scrollHeight
      }, 100)
    });

    function show_history_text() {
      let data

      switch (type.value) {
        case 'worker':
          data = {
            action: 'show_history_text',
            type: type.value,
            sender_id: info_chat.value.sender_id,
            receiver_id: info_chat.value.receiver_id,
          }
          break;

        case 'adver':
          data = {
            action: 'show_history_text',
            type: type.value,
            sender_id: info_chat.value.sender_id,
            receiver_id: info_chat.value.receiver_id,
            adver_id: info_chat.value.adver_id
          }
          break;

        case 'public':
          data = {
            action: 'show_history_text',
            type: type.value,
            sender_id: user_id.value,
            state_id: info_chat.value.state_id,
          }
          break;

        case 'profile_worker':
          data = {
            action: 'show_history_text',
            type: 'worker',
            sender_id: user_id.value,
            receiver_id: info_chat.value.receiver_id,
          }
          break;

        case 'profile_adver':
          data = {
            action: 'show_history_text',
            type: 'adver',
            sender_id: user_id.value,
            receiver_id: info_chat.value.receiver_id,
            adver_id: info_chat.value.adver_id
          }
          break;
      }

      FreeWorld.Heisenberg(data, 'user_chats').then((res) => {
        list_chats.value = res.data
        if (list_chats.value.length !== chats_length.value) {
          chats_length.value = list_chats.value.length
        }
      }).catch((res) => {
        Swals.Catch(res, show_history_text)
      })
    }
    show_history_text()

    function new_text() {
      if (text.value.trim().length === 0) return false

      let data

      switch (type.value) {
        case 'worker':
          data = {
            action: 'add_chat',
            type: type.value,
            sender_id: user_id.value,
            chats_id: info_chat.value.id,
            text: text.value
          }
          break;

        case 'adver':
          data = {
            action: 'add_chat',
            type: type.value,
            sender_id: user_id.value,
            chats_id: info_chat.value.id,
            adver_id: info_chat.value.adver_id,
            text: text.value
          }
          break;

        case 'public':
          data = {
            action: 'add_chat',
            type: type.value,
            sender_id: user_id.value,
            state_id: info_chat.value.state_id,
            text: text.value
          }
          break;

        case 'profile_worker':
          data = {
            action: 'add_chat',
            type: 'worker',
            sender_id: user_id.value,
            receiver_id: info_chat.value.receiver_id,
            text: text.value,
          }
          break;

        case 'profile_adver':
          data = {
            action: 'add_chat',
            type: 'adver',
            sender_id: user_id.value,
            receiver_id: info_chat.value.receiver_id,
            adver_id: info_chat.value.adver_id,
            text: text.value,
          }
          break;
      }


      FreeWorld.Heisenberg(data, 'user_chats').then((res) => {
        if (res.data.status === 'ok') {
          text.value = ''
          show_history_text()
        } else {
          Swals.Fault('پیام شما ارسال نشد!')
        }
      }).catch((res) => {
        Swals.Catch(res, new_text)
      })
    }

    function delete_chat(text_id, chat_id) {

      Swals.Question('آیا از حذف پیام اطمینان دارید؟' , 'حذف').then((res)=>{
        if (res.isConfirmed){

          let data = {
            action: 'delete_chat',
            type: type.value,
            text_id: text_id,
            chat_id: chat_id
          }
          if (type.value === 'profile_worker') data.type = 'worker'
          if (type.value === 'profile_adver') data.type = 'adver'

          FreeWorld.Heisenberg(data, 'user_chats', true).then((res) => {
            if (res.data.status === 'ok') {
              Swals.Done('پیام شما با موفقیت حذف شد')
              show_history_text()
            } else {
              Swals.Fault('متاسفانه پیام شما پاک نشد!')
            }
          }).catch((res) => {
            Swals.Catch(res, () => {
              delete_chat(text_id, chat_id)
            })
          })

        }
      })
    }

    function report_chat(text_id) {
      Swals.Question('آیا از گزارش این پیام اطمینان دارید؟' , 'گزارش').then((res)=>{

        if (res.isConfirmed){
          FreeWorld.Heisenberg({action: 'report_chat', type: type.value, text_id: text_id,}, 'user_chats', true).then((res) => {
            if (res.data.status === 'ok') {
              Swals.Done('گزارش شما با موفقیت ثبت شد')
            }else if(res.data.event === 'you reported this text before'){
              Swals.Warning('شما قبلا این پیام را گزارش داده اید!')
            } else {
              Swals.Fault('متاسفانه گزارش شما ثبت نشد!')
            }
          }).catch((res) => {
            Swals.Catch(res, () => {
              delete_chat(text_id, info_chat.value.id)
            })
          })
        }

      })
    }

    return {
      loading,
      new_text,
      user_id,
      list_chats,
      text,
      info_chat,
      delete_chat,
      type,
      report_chat,
    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div dir="ltr" :class="loading ? 'activeClass':''" id="main">
    <div class="p-3 position-fixed w-100 max_width top-0 bg-main border-bottom z-2">
      <div class="d-flex justify-content-between">
        <img onclick="window.history.back()" class="icon-size-0-5" src="../assets/img/icon-arrowBack.svg" alt="">

        <div class="d-flex align-items-center justify-content-between">
          <p class="font-4 text-color font-bold">{{ info_chat.chat_info }}</p>

          <div class="profile animated-background ms-2">
            <img v-if="info_chat.pic === null" class="profile" src="../assets/img/defult-profile.svg" alt="">
            <img v-else class="profile" :src="info_chat.pic" alt="">
          </div>
        </div>
      </div>
    </div>
    <br>
    <br>
    <br>
    <br>

    <div id="chat-list" class="mt-3">
      <div v-for="item in list_chats" :key="item.id" class="px-3 mb-3 d-flex"
           :class="user_id === item.sender_id ? 'justify-content-end':'justify-content-start'">
        <div class="animate__animated animate__fadeIn w-70 rounded-4 p-3 shadow-custom"
             :class="user_id === item.sender_id ? '':'bg-color-blue-light'">
          <p dir="rtl" class="font-4 text-color font-bold mb-4">{{ item.text }}</p>

          <div class="d-flex justify-content-between align-items-center">
            <img v-if="user_id === item.sender_id" @click="delete_chat(item.id , item.users_chat_id)"
                 class="icon-size-0-5" src="../assets/img/icon-binColor.svg" alt="">
            <img v-if="type === 'public' && item.sender_id !== user_id" @click="report_chat(item.id)" class="icon-size-1" src="../assets/img/icon-block-user.svg" alt="">

            <p class="font-5">{{ item.time }}</p>
          </div>
        </div>
      </div>
    </div>

    <br>
    <br>
    <br>
    <br>
    <div
        class="d-flex align-items-center justify-content-between p-3 pt-1 position-fixed bottom-0 w-100 max_width bg-main">
      <input v-model="text" id="input-chat" class="shadow-custom w-80 rounded-pill font-4 p-3" type="text" @keydown.enter="new_text" placeholder="پیام">

      <img @click="new_text" class="icon-size-7" src="../assets/img/icon-sendChats.svg" alt="">
    </div>
  </div>

</template>

<style scoped>
.profile {
  width: 4.5rem;
  height: 4.5rem;
  border-radius: 50%;
}

#input-chat::placeholder {
  text-align: center;
}

#chat-list {
  scroll-behavior: smooth;
  overflow: auto;
  overscroll-behavior-y: contain;
  height: calc(100% - 12rem);
}
</style>